import { render, staticRenderFns } from "./xitongduijie-saas.vue?vue&type=template&id=b99604f2&scoped=true&"
import script from "./xitongduijie-saas.vue?vue&type=script&lang=ts&"
export * from "./xitongduijie-saas.vue?vue&type=script&lang=ts&"
import style0 from "./xitongduijie-saas.vue?vue&type=style&index=0&id=b99604f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99604f2",
  null
  
)

export default component.exports